import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { useConditions } from 'mailup-react-helpers'

import {
  Panel,
  SPACING_8,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD,
  Uploader,
  UPLOADER_VARIANT_DANGER,
  UPLOADER_VARIANT_UPLOADING,
  UploadingFile
} from 'mailup-web-components'

import { uploadAttachmentsCallback } from 'Pages/OverviewMessage/recoil/callbacks/callbacks'
import { canUploadState } from 'Pages/OverviewMessage/recoil/state/message'
import { uploaderState } from 'Pages/OverviewMessage/recoil/state/uploader'

import { MESSAGE_ATTACHMENT_ALLOWED_EXT } from 'Constants/index'

import Attachments from './Attachments'

const BoxAttachments = () => {
  const intl = useIntl()
  const [hasAttachments] = useConditions(['uo:ATTACH AND co:ATTACH'])

  const { variant, hintDanger, uploading } = useRecoilValue(uploaderState)
  const canUpload = useRecoilValue(canUploadState)

  const handleUploaderChange = useRecoilCallback(uploadAttachmentsCallback, [])

  const hintDefault = intl
    .formatMessage({
      id: 'Load.SavedEmailWizard.AttachmentUploadDescriptionDrag'
    })
    .replace('{X}', '5')
    .replace('{Y}', '7')

  const hintDisabled = intl.formatMessage({
    id: 'Load.SavedEmailWizard.UploadFileLimit'
  })

  const hint = !canUpload
    ? hintDisabled
    : variant === UPLOADER_VARIANT_DANGER
    ? hintDanger
    : hintDefault

  const value =
    variant === UPLOADER_VARIANT_UPLOADING ? (
      <UploadingFile
        name={uploading.name}
        size={`${intl.formatNumber(uploading.size)} KB`}
      />
    ) : (
      undefined
    )

  return (
    <>
      <Panel data-mu-test='overview-message__box-attachments'>
        <Text variant={TEXT_VARIANT_BOLD}>
          {intl.formatMessage({ id: 'Load.SavedEmailWizard.AttachmentsTitle' })}
        </Text>
        <SpacingVertical variant={SPACING_8} />
        {hasAttachments ? (
          <>
            <Uploader
              inputId='message-attachments'
              variant={variant}
              disabled={!canUpload}
              hint={hint}
              accept={MESSAGE_ATTACHMENT_ALLOWED_EXT}
              value={value}
              onChange={handleUploaderChange}
            >
              <span>
                {intl.formatMessage({
                  id: 'Load.ContentsSouces.FileUploaderTitle'
                })}{' '}
                <label htmlFor='message-attachments'>
                  {intl.formatMessage({
                    id: 'Load.EmailMessageImport.fileUploaderBrowseLabel'
                  })}
                </label>
              </span>
            </Uploader>
            <Attachments />
          </>
        ) : (
          <Text>
            {intl.formatMessage({
              id: 'Load.SavedEmailWizard.AttachmentsUpselling'
            })}
          </Text>
        )}
      </Panel>
    </>
  )
}

export default BoxAttachments
